import * as qs from 'qs';
import axios, { AxiosResponse } from 'axios';
import { IObject } from '../Interfaces';

class ApiSync {
  private lang: string;

  constructor(public url: string) {
    this.lang = document.body.dataset.lang;
  }

  public fetch<T>(params?: IObject): Promise<T> {
    return axios({
      url: this.url,
      method: 'get',
      params: {
        lang: this.lang,
        ...params
      }
    }).then((response: AxiosResponse<T>) => response.data);
  }

  public save<T, K>(data: K): Promise<T> {
    return axios({
      url: this.url,
      method: 'post',
      params: {
        lang: this.lang
      },
      data: qs.stringify({
        ...data
      }),
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then((response: AxiosResponse<T>) => response.data);
  }

  public delete<T, K>(data: K): Promise<T> {
    return axios({
      url: this.url,
      method: 'delete',
      params: {
        lang: this.lang
      },
      data: qs.stringify({
        ...data
      }),
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then((response: AxiosResponse<T>) => response.data);
  }
}

export default ApiSync;
